import React from "react";

import AnswerMapping from "./AnswerMapping";
import useTranslations from "../../hooks/useTranslations";
import { useBreadcrumbs } from "../../hooks/useBreadcrumbs";

const EvaluationMapping: React.FC = () => {
    const t = useTranslations();
  
    useBreadcrumbs([
      {
        to: "/analytics/evaluation-mapping",
        text: t("statistics.evaluations") as string,
      },
    ]);
    
    return (
      <AnswerMapping
        title={t("statistics.evaluations")}
        description={t("statistics.statisticsEvaluationsDescription")}
        questionTypes={[ "QuestionEvaluation" ]}
        defaultIsCollaborator={false}
        buildUrl={({ digest }) => `/analytics/evaluations/${digest}`}
      />
    )
}

export default React.memo(EvaluationMapping)